import { t } from "@/lib/i18n";
import { Search, X } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";

const Chip = ({ active, onClick, color, label, count, Icon, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`flex shrink-0 items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-semibold transition-colors ${
      active ? "border-ac-strong bg-ac-strong text-white" : "border-ac-line bg-ac-surface text-ac-text hover:border-ac-muted"
    }`}
  >
    {Icon ? <Icon className="h-3.5 w-3.5" style={{ color: active ? "#fff" : color }} /> : null}
    {label}
    <span className={`rounded-full px-1.5 font-mono text-[10px] ${active ? "bg-white/20" : "bg-ac-surface3 text-ac-muted"}`}>{count}</span>
  </button>
);

export const FilterBar = ({ query, setQuery, category, setCategory, counts, total }) => (
  <div className="space-y-3">
    <div className="relative">
      <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-ac-faint" />
      <input
        data-testid="search-input"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={t("search.ph")}
        className="h-12 w-full rounded-xl border border-ac-line bg-ac-surface pl-12 pr-11 text-sm text-ac-text outline-none transition-shadow placeholder:text-ac-faint focus:border-ac-primary focus:ring-4 focus:ring-ac-primary-ring"
      />
      {query && (
        <button data-testid="search-clear-button" onClick={() => setQuery("")} className="absolute right-4 top-1/2 -translate-y-1/2 text-ac-faint hover:text-ac-text">
          <X className="h-5 w-5" />
        </button>
      )}
    </div>
    <div className="flex flex-wrap gap-1.5">
      <Chip testId="category-chip-all" active={category === "all"} onClick={() => setCategory("all")} label={t("chip.all")} count={total} />
      {Object.entries(CATEGORIES).map(([k, c]) => (
        <Chip key={k} testId={`category-chip-${k}`} active={category === k} onClick={() => setCategory(category === k ? "all" : k)} color={c.color} Icon={c.Icon} label={c.short} count={counts[k] || 0} />
      ))}
    </div>
  </div>
);
